<template>
    <div :id="getDivId()">

    </div>
</template>

<script>
export default {
    props: {
      options: {
          type: Object,
          required: true
      },
    },
    mounted() {
        hbspt.forms.create({
            portalId: this.options.portalId,
            formId: this.options.formId,
            css: '',
            target: '#'+this.getDivId()
        });
    },
    methods: {
        getDivId() {
            return "hubspot-"+this._uid;
        }
    }
}
</script>